import axios from 'axios';
import { Dispatch } from 'redux';
import { AuthAction, AuthActionTypes } from '../../types/auth';
import { setAlert } from './alert';
import { errorHandler } from '../../utils/service';
import { clearUsers } from './user';
import { clearNpcByBrand } from './npcByBrand';
import { clearNpcByItem } from './npcByItem';
import { clearWarehouse } from './warehouse';
import { clearNpcFbaFreight } from './npcFbaFreight';
import { clearNpcStorage } from './npcStorage';
import { clearInboundFreight } from './npcInboundFreight';
import { clearItemlookup } from './itemlookup';

const config = {
  headers: {
    'Content-Type': 'application/json'
  }
};

export const login =
  (data: any) => async (dispatch: Dispatch<AuthAction | any>) => {
    const body = JSON.stringify(data);
    try {
      dispatch({
        type: AuthActionTypes.ADD_LOADING
      });

      const res = await axios.post('/api/auth/login', body, config);
      dispatch({
        type: AuthActionTypes.LOGIN_SUCCESS,
        payload: res.data
      });
    } catch (error: any) {
      errorHandler({ error, dispatch, setAlert });
      dispatch({
        type: AuthActionTypes.LOGIN_FAIL
      });
    }
  };

export const loadUser = () => async (dispatch: Dispatch<AuthAction | any>) => {
  try {
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common['Authorization'] = token;
    } else {
      dispatch({
        type: AuthActionTypes.LOAD_USER_FAIL
      });
      return;
    }
    const res = await axios.get('/api/auth/user');
    dispatch({
      type: AuthActionTypes.LOAD_USER,
      payload: res.data
    });
  } catch (error) {
    errorHandler({ error, dispatch, setAlert });
    dispatch({
      type: AuthActionTypes.LOAD_USER_FAIL
    });
  }
};

export const setUrl =
  (url: string) => async (dispatch: Dispatch<AuthAction>) => {
    dispatch({
      type: AuthActionTypes.SET_URL,
      payload: url
    });
  };

export const logout = () => async (dispatch: Dispatch<AuthAction | any>) => {
  dispatch({
    type: AuthActionTypes.LOGOUT
  });
  dispatch(clearUsers());
  dispatch(clearNpcByBrand());
  dispatch(clearNpcByItem());
  dispatch(clearWarehouse());
  dispatch(clearNpcFbaFreight());
  dispatch(clearNpcStorage());
  dispatch(clearInboundFreight());
  dispatch(clearItemlookup());
};
